module.exports = __webpack_public_path__ + "static/img/bg.aaa4652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 11
// module chunks = 0